<template>
  <v-dialog v-model="testTemplateDialog" fullscreen transition="dialog-bottom-transition" :overlay=false>
    <v-card class="elevation-1 template-details">
      <v-toolbar color="primary white--text">
        <v-toolbar-title>
          <span>{{ messages.label.TEST_TEMPLATE }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn @click.stop="hide" flat>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap>
            <v-flex md4 sm4>
              <v-combobox v-model="selectedProviderGroup" :label="messages.label.PROVIDER_GROUP" v-validate="'required'"
                :error-messages="errors.collect('providerGroup')" data-vv-name="providerGroup"
                :items="providerGroupsList" item-text="title" item-value="title" return-object required>
              </v-combobox>
            </v-flex>
            <v-flex md4 sm4>
              <v-select v-model="testTemplateDetails.template" :label="messages.label.TEMPLATE" v-validate="'required'"
                :error-messages="errors.collect('template')" data-vv-name="template" :items="templateList"
                item-text="title" item-value="title" required>
              </v-select>
            </v-flex>
            <v-flex md4 sm4>
              <v-select v-model="testTemplateDetails.translator" :label="messages.label.TRANSLATOR"
                v-validate="'required'" :error-messages="errors.collect('translator')" data-vv-name="translator"
                :items="translatorsList" item-text="title" item-value="value" required>
              </v-select>
            </v-flex>
            <v-flex md7 sm7>
              <v-text-field v-model="plannerFileName" clearable append-icon="get_app" v-validate="'required'"
                :error-messages="errors.collect('plannerPath')" data-vv-name="plannerPath"
                :label="messages.label.PLANNER" @click="uploadFile()" required>
              </v-text-field>
              <input type="file" style="display: none" ref="plannerFile" accept=".xlsx" @change="onFileUpload">
            </v-flex>
            <v-flex md2>
              <v-btn color="primary" @click="testTemplate()">{{ messages.label.TEST }}</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-card flat>
            <v-card-title class="pa-0 mt-2">
              <h6 class="title">ADI Response</h6>
            </v-card-title>
            <v-card-text>
              <v-alert color="info" :value="true" class="black--text" icon="info" v-if="!initiatedTest">
                {{ messages.info.RESPONSE_INFO }}
              </v-alert>
              <v-card :height="editorHeight" v-show="initiatedTest">
                <div ref="editorReadOnly" class="vop--ace-editor"></div>
              </v-card>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ProvidersService from "@/Providers/ProvidersService"
import messages from "@/Providers/messages.json"
import ace from "brace"
import "brace/mode/xml"
import "brace/theme/eclipse"
import "brace/ext/searchbox"

export default {
  name: "TestTemplate",
  components: {},
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      testTemplateDialog: false,
      testTemplateDetails: {
        template: "",
        translator: ""
      },
      plannerFileName: "",
      plannerFilePath: "",
      plannerFile: "",
      testTemplateResponseMsg: "",
      testTemplateResultingXML: "",
      providerGroupsList: [],
      selectedProviderGroup: {},
      hasXMLError: false,
      initiatedTest: false,
      translatorsList: this.retrieveTranslators(),
      dictionary: this.getValidationDictionary()
    }
  },
  computed: {
    editorHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "55vh"
        case "sm":
          return "55vh"
        case "md":
          return "58vh"
        case "lg":
          return "58vh"
        case "xl":
          return "70vh"
      }
    },
    /**
     * templateList  - Mock data for template list based on selected provider group
     *
     * @return {array}
     */
    templateList() {
      if (this.selectedProviderGroup !== undefined) {
        // Make API call to retrive template list based on selected provider group
        let templateList = [
          {
            title: this.selectedProviderGroup.title + " Provider Template",
            description: "Provider Template",
            enabled: true
          }
        ]
        return templateList
      }
    }
  },
  methods: {
    /**
     * Hide Test Template Modal
     */
    hide() {
      this.resetTemplateData()
      this.testTemplateDialog = false
    },
    /**
     * Show Test Template Modal
     */
    show(providerGroupObj) {
      this.resetTemplateData()
      this.$validator.reset()
      this.selectedProviderGroup = this.providerGroupsList.find(
        (obj) => obj.id === providerGroupObj.id
      )
      this.testTemplateDialog = true
    },
    /**
     * retrieveProviderGroups - Retrieve all provider groups by making API call
     */
    retrieveTranslators() {
      let translators = [
        {
          title: "Row Based Translator",
          value: "translateRowBasedPlanner"
        }
      ]
      return translators
    },
    /**
    * Open XML Editor
    */
    openXMLEditor() {
      let editor
      editor = ace.edit(this.$refs.editorReadOnly)
      editor.setReadOnly(true)
      editor.setTheme("ace/theme/eclipse")
      editor.getSession().setMode("ace/mode/xml")
      editor.session.setValue(this.testTemplateResultingXML)
      editor.getSession().on("changeAnnotation", (event) => {
        this.validateXML(event, editor)
      })
    },
    /**
    * Check if XML is in valid state, if not disable 'CONTINUE' button
    */
    validateXML(event, editor) {
      let xmlSyntaxError = false
      let annotationLists = editor.getSession().getAnnotations()
      for (var i in annotationLists) {
        let annotationError = annotationLists[i].type
        if (annotationError === "error" || annotationError === "warning") {
          xmlSyntaxError = true
          break
        }
      }
      if (xmlSyntaxError) {
        this.hasXMLError = true
      } else {
        this.hasXMLError = false
      }
    },
    /**
    * Test Template
    */
    testTemplate() {
      // Make API call for Test Template
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.testTemplateResultingXML = this.messages.testXML
          this.openXMLEditor()
          this.initiatedTest = true
        }
      })
    },
    /**
    * open the dialog for uploading the file from system
    */
    uploadFile() {
      this.$refs.plannerFile.click()
    },
    /**
    * when user clicks on file in uplaod dialog
    */
    onFileUpload(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.plannerFileName = files[0].name
        if (this.plannerFileName.lastIndexOf(".") <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener("load", () => {
          this.plannerFilePath = fr.result
          this.plannerFile = files[0] // this is the csv file that can be sent to server
        })
      } else {
        this.plannerFileName = ""
        this.plannerFilePath = ""
        this.plannerFile = ""
      }
    },
    /**
    * Validation messages for vee-validate
    */
    getValidationDictionary() {
      return {
        custom: {
          providerGroup: {
            required: () => "Please select a Provider Group"
          },
          template: {
            required: "Please select a Template"
          },
          translator: {
            required: "Please select a Translator"
          },
          plannerPath: {
            required: () => "Planner Path can't be empty"
          }
        }
      }
    },
    /**
     * Re-initialize
     */
    resetTemplateData() {
      this.testTemplateDetails = {
        template: "",
        translator: ""
      }
      this.plannerFileName = ""
      this.plannerFilePath = ""
      this.plannerFile = ""
      this.testTemplateResponseMsg = ""
      this.testTemplateResultingXML = ""
      this.selectedProviderGroup = ""
      this.testTemplateResponse = ""
      this.hasXMLError = false
      this.initiatedTest = false
    }
  },
  mounted() {
    this.$validator.localize("en", this.dictionary)
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages

    /**
     * Events
     */
    ProvidersService.$on("event:showTestTemplateModal", (providerGroupObj) => {
      this.show(providerGroupObj)
    })
  }
}
</script>

<style lang="scss" scoped>
.vop--ace-editor {
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: 20px;
  right: 20px;
}

.vop--ace-editor .ace_search_field,
.ace_searchbtn:last-child {
  color: black !important;
}

.template-details {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/Providers/ProviderGroups/TestTemplate.vue